import { stringSearch } from '@luminovo/design-system';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import type { JSX } from 'react';

import { MonitoringSidebarLayout } from '@/areas/market-insights/MarketInsights/app/MonitoringSidebarLayout';
import type { PageStaticData } from '@/shared/routing';

// Pages next to the sidebar; `analysis` and `charts/$chartId` fill the screen, so they stay outside this group.
// Declares `ids`, the node view's selection, so the sidebar reads it on every page: `/monitoring` is Home without it.
export const Route = createFileRoute('/_authenticated/monitoring/_sidebar')({
    // The monitoring layout (`monitoring/route.tsx`) checks who may open its pages.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    validateSearch: stringSearch({ ids: 'optional' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return (
        <MonitoringSidebarLayout>
            <Outlet />
        </MonitoringSidebarLayout>
    );
}
